export default __webpack_public_path__ + "static/media/Microsoft_Office.3873d288.svg";